import { render, staticRenderFns } from "./pvUnAllocCollList.vue?vue&type=template&id=73a9c55f&scoped=true&"
import script from "./pvUnAllocCollList.vue?vue&type=script&lang=js&"
export * from "./pvUnAllocCollList.vue?vue&type=script&lang=js&"
import style0 from "./pvUnAllocCollList.vue?vue&type=style&index=0&id=73a9c55f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a9c55f",
  null
  
)

export default component.exports